<template>
	<ui-card
		icon="fal fa-ballot-check"
		title="Campos da Proposta"
		text="Informe os campos complementares do cliente no guia de propostas."
	>
		<template #body>
			<ui-load-success
				v-if="loader.overlay"
				:loading="loader.overlayLoading"
				:success="loader.overlaySucess"
			/>

			<div class="area-card min-100">
				<transition name="small">
					<div v-show="loader.body" class="loading-card">
						<ui-load-indicator bgColor="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
					</div>
				</transition>

				<transition-group name="list" tag="div" class="grid-50 list-t">
					<div v-for="field in proposalGroup" :key="field.id">
						<div v-if="!isFieldRepeater(field.fields)" class="pb-2">
							<ui-select-2
								v-model="form.fields[field.id]"
								:data="field.fields"
								:search="false"
								:showFooter="false"
								:label="field.name"
								item-label="label"
								multiple
							/>
						</div>

						<div v-else class="pb-2">
							<ui-select-2
								v-model="form.fields[field.id]"
								:data="boolOptions"
								:search="false"
								:showFooter="false"
								:label="field.name"
								item-label="label"
								return-value="value"
							/>
						</div>
					</div>
				</transition-group>
			</div>
		</template>
		<template #fl></template>
		<template #fr>
			<ui-button design="md success" :disabled="!canSubmit" @click="submit">Salvar</ui-button>
		</template>
	</ui-card>
</template>
<script>
	import { uiCard } from '@/components/ui/cards'
	import { uiButton } from '@/components/ui/buttons'
	import { uiSwitch, uiSelect2 } from '@/components/ui/form'
	import { uiLoadIndicator } from '@/components/ui'
	import { uiLoadSuccess } from '@/components/ui/overlays'

	import { utilMixin, formMixin, alertMixin } from '@/mixins'
	import { getConfig, saveConfig, getProposalGroup } from '../../util/methods'

	const defaultForm = () => ({
		fields: {},
	})

	const defaultDisabled = () => ({})
	const defaultChecked = () => ({})

	const defaultLoader = () => ({
		body: false,
		overlay: false,
		overlayLoading: true,
		overlaySucess: true,
		list: false,
	})

	export default {
		name: 'configuration-proposal-required-fields',

		components: {
			uiCard,
			uiButton,
			uiSelect2,
			uiSwitch,
			uiLoadSuccess,
			uiLoadIndicator,
		},

		mixins: [utilMixin, formMixin, alertMixin],

		data() {
			return {
				form: { ...defaultForm() },
				disabled: { ...defaultDisabled() },
				checked: { ...defaultChecked() },
				loader: { ...defaultLoader() },
				proposalSettings: [],
				proposalGroup: [],
				oldForm: {},
			}
		},

		async created() {
			this.loader.body = true
			this.loader.list = true

			this.proposalGroup = this.makeProposalGroup(await this.getProposalGroup())
			this.proposalSettings = await this.getConfig('proposalSettings', 'value_long')
			this.form.fields = this.makeSelectedOptions(
				this.proposalSettings.fields,
				this.proposalGroup,
			)

			this.loader.body = false
			this.$mx_copyOldForm()
		},

		computed: {
			canSubmit() {
				return this.$mx_isFormChanged && !this.loader.body
			},

			boolOptions() {
				const list = []
				const options = [
					['Sim', 'yes'],
					['Não', 'no'],
				]
				options.forEach((option, index) => {
					list.push({
						id: index,
						label: option[0],
						value: option[1],
					})
				})
				return list
			},

			validateProposaSettings() {
				const newFields = {}
				for (let field in this.form.fields) {
					if (Array.isArray(this.form.fields[field])) {
						newFields[field] = []
						this.form.fields[field].forEach((option) => {
							newFields[field].push(`${option.id}`)
						})
					} else newFields[field] = this.form.fields[field]
				}
				return {
					...this.proposalSettings,
					fields: {
						...newFields,
					},
				}
			},
		},

		methods: {
			getConfig,
			saveConfig,
			getProposalGroup,

			isFieldRepeater(fields) {
				let bool = false
				fields.forEach((item) => {
					if (item.type === 'repeater') bool = true
				})
				return bool
			},

			makeProposalGroup(proposalGroup) {
				const list = []
				proposalGroup.forEach((proposal) => {
					list.push({
						...proposal,
						fields: this.makeOptions(proposal.fields),
					})
				})
				return list
			},

			makeOptions(options) {
				const list = []
				options.forEach((item) => {
					if (item.type !== 'separator')
						list.push({
							...item,
							cover: '',
							text: '',
							label: item.name,
						})
				})
				return list
			},

			makeSelectedOptions(selecteds, options) {
				const fields = {}
				for (const select in selecteds) {
					options.forEach((option) => {
						if (fields[select] == undefined) fields[select] = []

						if (option.id == select)
							option.fields.forEach((f) => {
								if (Array.isArray(selecteds[select]))
									selecteds[select].forEach((s) => {
										if (f.id == s)
											fields[select].push({
												...f,
												cover: '',
												text: '',
												label: f.name,
											})
									})
								else fields[select] = selecteds[select]
							})
					})
				}
				return fields
			},

			async submit() {
				try {
					this.loader.overlay = true
					this.loader.overlayLoading = true

					await this.saveConfig(
						'proposalSettings',
						this.validateProposaSettings,
						'value_long',
					)

					setTimeout(() => {
						this.loader.overlayLoading = false
						this.loader.overlaySucess = true
						setTimeout(() => {
							this.loader.overlay = false
						}, 500)
					}, 500)

					this.$mx_copyOldForm()
					//...
				} catch (error) {
					this.$mx_alertThisOnError(error)
					this.loader.overlaySucess = false
					setTimeout(() => {
						this.loader.overlay = false
					}, 1000)
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
